import SecureLS from 'secure-ls';

const ls = new SecureLS({ encodingType: 'aes' });

// One-time migration: move plain localStorage data to SecureLS
// This handles users who were logged in before the encryption change
const migrateKey = (key, fallback) => {
  try {
    // Try reading from SecureLS first
    const secureData = ls.get(key);
    if (secureData) return secureData;
  } catch {
    // SecureLS couldn't read — might not exist yet
  }

  // Check for legacy plain-text localStorage data
  try {
    const raw = localStorage.getItem(key);
    if (raw) {
      const parsed = JSON.parse(raw);
      // Migrate to SecureLS and remove the plain-text copy
      ls.set(key, parsed);
      localStorage.removeItem(key);
      return parsed;
    }
  } catch {
    // Not valid JSON or doesn't exist
  }

  return fallback;
};

// User data (PII: email, phone, name, DOB)
export const getUser = () => {
  try {
    return migrateKey('user', null);
  } catch {
    return null;
  }
};
export const setUser = (data) => ls.set('user', data);
export const removeUser = () => {
  ls.remove('user');
  localStorage.removeItem('user'); // Also clean up any legacy data
};

// Families data (contains roles)
export const getFamilies = () => {
  try {
    return migrateKey('families', []);
  } catch {
    return [];
  }
};
export const setFamilies = (data) => ls.set('families', data);
export const removeFamilies = () => {
  ls.remove('families');
  localStorage.removeItem('families'); // Also clean up any legacy data
};
